import React from 'react';
import { Column } from 'rbx';
import { RiEdit2Fill } from 'react-icons/ri';

const ItemNameAndRemoveButton = ({
  itemLink,
  // menu_item,
  // item_link_id,
  // setFieldValue,
  // selectedLinkIds,
  onEdit,
}) => (
  <Column.Group
    style={{
      backgroundColor: '#fbf8f8',
      borderBottom: '1px solid #b0b0b0',
    }}
  >
    <Column size={6}>{itemLink.name}</Column>
    <Column
      size={6}
      style={{ fontSize: '13px', cursor: 'pointer', color: '#EE2A7B' }}
    >
      <Column.Group>
        <Column size={5} />
        <Column
          size={1}
          style={{ cursor: 'pointer', color: 'black', fontSize: '16px' }}
        >
          <RiEdit2Fill size={18} onClick={onEdit} />
        </Column>
      </Column.Group>
    </Column>
  </Column.Group>
);

export default ItemNameAndRemoveButton;
